import React from 'react';
import {observer} from 'mobx-react';

import {usePromotions} from '../../queries/promotions';
import {createFilterForStoreFulfilment} from '../../queries/promotions/predicates';
import {useStores} from '../../stores/use-stores';

import PromotionsListScreenBase from './PromotionsListScreenBase';

const PromotionsListScreen = observer(() => {
  const {shopSelectionStore} = useStores();
  const {listedPromotions} = usePromotions();

  const canSellOnline = shopSelectionStore.canPickup || shopSelectionStore.canDeliver;
  const activations = (listedPromotions ?? []).filter(
    createFilterForStoreFulfilment(canSellOnline),
  );

  return <PromotionsListScreenBase promotions={activations} />;
});

export default PromotionsListScreen;
